import { useState } from 'react';
import styles from './index.module.css';

const Button = (props) => {
    const { title, onClick } = props;
    const [isHover, setIsHover] = useState(false);
    return (
        <div
            className={styles['button']}
            onMouseLeave={() => {
                setIsHover(false);
            }}
            onMouseEnter={() => {
                setIsHover(true);
            }}
            style={{
                background: isHover ? '#01D598' : '#fff',
            }}
            onClick={onClick}
        >
            <div
                className={styles['btn-title']}
                style={{
                    color: isHover ? '#fff' : '#01D598',
                }}
            >
                {title}
            </div>
            <div
                className={styles['icon-box']}
                style={{
                    background: isHover ? '#fff' : '#01D598',
                }}
            >
                <div
                    className={styles['icon']}
                    style={{
                        borderLeft: `8px solid ${isHover ? '#01D598' : '#fff'}`
                    }}
                >
                    &nbsp;
                </div>
            </div>
        </div>
    )
}

export default Button;